export const descriptionElement = {
  addNewDescriptionElement: "Add new description element",
  selectNoteFromListOr: "Select note from list or",
  createNew: "Create new"
};
